<!-- Se abre en un modal desde la ficha del cliente, que ya pone el título -->
<div>
  <div>
    @if (cliClienteId) {
      <div class="mb-3 flex justify-end">
        <app-button *hasPermission="'clientes:create'" [startIcon]="'add'" (btnClick)="openCreateModal()">Nuevo contacto</app-button>
      </div>
    }

    @if (!cliClienteId) {
      <div class="text-center py-8">
        <p class="text-gray-500 dark:text-gray-400">
          Debe seleccionar un cliente para gestionar contactos.
        </p>
      </div>
    } @else {
      <!-- Filtros -->
      <app-filters-container
        [hasData]="contactosAdministrativos.length > 0"
        [hasActiveFilters]="hasActiveFilters"
        [loading]="loading"
        (clearFilters)="clearFilters()"
      >
        <app-search-input
          label="Buscar"
          placeholder="Buscar por nombre, email o celular..."
          [value]="searchTerm"
          (searchChange)="onSearchChange($event)"
        />

        <app-filter-select
          label="Estado"
          [value]="selectedEstado"
          [options]="estadoOptions"
          (valueChange)="onEstadoChange($event)"
        />

        <app-filter-select
          label="Origen"
          [value]="selectedOrigen"
          [options]="origenOptions"
          (valueChange)="onOrigenChange($event)"
        />

        <app-filter-select
          label="Tipo de contacto"
          [value]="selectedTipoContacto"
          [options]="tipoContactoOptions"
          (valueChange)="onTipoContactoChange($event)"
        />
      </app-filters-container>

      <!-- Tabla -->
      <app-data-table
        [columns]="columns"
        [data]="contactosAdministrativos"
        [loading]="loading"
        [emptyTitle]="'No hay contactos registrados'"
        [emptySubtitle]="'Prueba ajustando los filtros o crea un nuevo contacto'"
        (rowClick)="onRowClick($event)"
      >
        <!-- Nombre -->
        <ng-template appTableCell="nombre" let-contacto>
          {{ contacto.nombre + ' ' + contacto.apellido }}
        </ng-template>

        <!-- Contacto -->
        <ng-template appTableCell="contacto" let-contacto>
          <div class="flex flex-col">
            <span class="text-sm">Email: {{ contacto.email }}</span>
            <span class="text-sm text-gray-500 dark:text-gray-400">Celular: {{ contacto.celular }}</span>
          </div>
        </ng-template>

        <!-- Origen -->
        <ng-template appTableCell="origen" let-contacto>
          @if (contacto.origen === 'E') {
            <app-badge [color]="'light'">{{ contacto.establecimiento?.nombre || 'Establecimiento' }}</app-badge>
          } @else {
            <app-badge [color]="'info'">Administrativo</app-badge>
          }
        </ng-template>

        <!-- Estado -->
        <ng-template appTableCell="estado" let-contacto>
          @if (contacto.activo) {
            <app-badge [color]="'success'">Activo</app-badge>
          } @else {
            <app-badge [color]="'error'">Inactivo</app-badge>
          }
        </ng-template>

        <!-- Tipo -->
        <ng-template appTableCell="tipo" let-contacto>
          {{ contacto.establecimiento_tipo_contacto.nombre }}
        </ng-template>

        <!-- Acciones -->
        <ng-template appTableCell="acciones" let-contacto let-index="index">
          <div class="flex items-center gap-x-2.5">
            <button
              (click)="openViewModal(contacto.id); $event.stopPropagation()"
              [matTooltip]="'Ver contacto'"
            >
              <mat-icon class="dark:text-gray-400!">visibility</mat-icon>
            </button>
            <app-delete-trigger *hasPermission="'clientes.registros:delete'"
              [title]="'Eliminar contacto'"
              [disabled]="deleting && deletingIndex === index"
              (clickDeleteEvent)="delete(contacto.id, index); $event.stopPropagation()"
            />
          </div>
        </ng-template>
      </app-data-table>

      <!-- Paginación -->
      <app-pagination
        [currentPage]="currentPage"
        [lastPage]="lastPage"
        [perPage]="perPage"
        [total]="total"
        (pageChange)="onPageChange($event)"
        (perPageChange)="onPerPageChange($event)"
      />
    }
  </div>
</div>
